import type {AlertItem} from '../index';
import type {FC} from 'react';
import useModal from '../../../hooks/useModal.tsx';
import {Button, ButtonGroup, Container, Message, Overlay, Title} from './Alert.styled.ts';

interface AlertProps {
    item: AlertItem;
}

const Alert: FC<AlertProps> = ({item}) => {
    const {close} = useModal();
    const {alertType, title, message, id, zIndex} = item;

    const handleClose = () => {
        close(id);
    };

    const handleConfirm = () => {
        if (item.onConfirm) {
            item.onConfirm();
        }
        close(id);
    };

    return (
        <Overlay zIndex={zIndex}>
            <Container type={alertType}>
                <Title>{title}</Title>
                <Message>{message}</Message>
                <ButtonGroup>
                    {alertType === 'confirm' ? (
                        <>
                            <Button onClick={handleConfirm} colorType={alertType}>
                                확인
                            </Button>
                            <Button onClick={handleClose}>취소</Button>
                        </>
                    ) : (
                        <Button onClick={handleClose} colorType={alertType}>
                            확인
                        </Button>
                    )}
                </ButtonGroup>
            </Container>
        </Overlay>
    );
};

export default Alert;
